import { render } from "./addAssets.vue?vue&type=template&id=527b3ea0&scoped=true"
import script from "./addAssets.vue?vue&type=script&lang=js"
export * from "./addAssets.vue?vue&type=script&lang=js"

import "./addAssets.vue?vue&type=style&index=0&id=527b3ea0&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527b3ea0"]])

export default __exports__